/**
 * DispoRowNote — Jun-2026 (User-Wunsch).
 *
 * „Interner Vermerk"-Feld. Speichert automatisch (onBlur) über den bestehenden
 * Dispo-Endpoint. Nur intern sichtbar.
 *  - variant="inline" (Standard): schlankes Inline-Feld (Listenzeile).
 *  - variant="block": volle Breite als Textarea (Bereich „Disposition &
 *    Verkaufsabwicklung" unter den archivierten Dokumenten).
 */
import { useState } from "react";
import api from "../../lib/api";

export default function DispoRowNote({ listingId, initialNote = "", variant = "inline" }) {
    const [note, setNote] = useState(initialNote || "");
    const [saved, setSaved] = useState(initialNote || "");

    const save = async () => {
        if (note === saved) return;
        try {
            await api.patch(`/listings/${listingId}/dispo/internal-note`, { note });
            setSaved(note);
        } catch { /* lokalen Wert behalten — Fehler nicht eskalieren */ }
    };

    if (variant === "block") {
        return (
            <textarea
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onBlur={save}
                rows={3}
                placeholder="Interne Notizen zur Disposition (nur intern sichtbar)…"
                className="w-full rounded-sm border border-gray-200 bg-amber-50/50 px-2.5 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#111827] resize-y"
                data-testid={`disposition-internal-note-input-${listingId}`}
            />
        );
    }

    return (
        <div className="flex-1 min-w-0 flex items-center gap-1.5" data-testid={`disposition-row-note-${listingId}`}>
            <span className="text-gray-500 font-bold text-[11px] whitespace-nowrap">Interner Vermerk:</span>
            <input
                value={note}
                onChange={(e) => setNote(e.target.value)}
                onBlur={save}
                onKeyDown={(e) => { if (e.key === "Enter") e.currentTarget.blur(); }}
                placeholder="Interne Notizen zur Disposition (nur intern sichtbar)…"
                title="Nur intern sichtbar · auto-gespeichert"
                className="flex-1 min-w-0 rounded-sm border border-gray-200 bg-amber-50/50 px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-[#111827]"
                data-testid={`disposition-row-note-input-${listingId}`}
            />
        </div>
    );
}
